import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Element from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/index.less';
import '@/assets/css/reset.css';
import './utils/rem';
import http from './api';


Vue.use(Element);
Vue.config.productionTip = false
Vue.prototype.$http = http;
Vue.prototype.$qiNiuUri = 'https://djimg.gobestsoft.cn/'; // 七牛地址

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
